import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CandidateService } from '../candidate/candidate.service';
import { ApiService } from 'src/app/shared/ApiService/api.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  loggedInuser: any;
  constructor(
    private router: Router,
    private jwthelper: JwtHelperService,
    private http: ApiService,
    private candidateService: CandidateService

  ) { }
  nextStep() {
    if (localStorage.getItem('access_token')) {
      const token = this.jwthelper.decodeToken(localStorage.getItem('access_token'));
      console.log(token);
      
      this.navigateAsPerRole(token.role);
    }
  }
  currentUser(): Observable<any> {
    const authUrl = environment.base_url + '/auth/me';
    return this.http.post(authUrl, localStorage.getItem('access_token'));
  }
  setCurrentUser(value?: any) {
    if (localStorage.getItem('access_token')) {
      if (!value) {
        this.currentUser().subscribe((res) => {
          this.loggedInuser = res;
        });
      } else {
        if (this.loggedInuser) {
          this.loggedInuser = Object.assign(this.loggedInuser, value);
        } else {
          this.loggedInuser = value;
        }
      }
    } else {
      this.loggedInuser = null;
    }
  }
  decodeToken(): Observable<any> {
    const token = localStorage.getItem('access_token');
    return this.jwthelper.decodeToken(token);
  }

  checkForExpiredToken() {
    const token = localStorage.getItem('access_token');
    if (token) {
      this.candidateService.setLoggedinUserCheck(this.jwthelper.isTokenExpired(token))
      return this.jwthelper.isTokenExpired(token);
    } else {
      this.candidateService.setLoggedinUserCheck(false);
      return false;
    }
  }

  navigateAsPerRole(role) {
    if (role === 'candidate') {
      this.router.navigate(['/candidate']);
    } else if (role === 'est_admin') {
      window.location.href = '/app/establishment/dashboard';
    } else if (role === 'college_admin') {
      window.location.href = '/app/college/dashboard';
    } else if (role === 'tpa_admin') {
      window.location.href = '/app/tpa/dashboard';
    } else if (role === 'nsdc_admin') {
      window.location.href = '/app/nsdc/dashboard';
    }  else if (role === 'nsdc_viewer') {
      window.location.href = '/app/nsdc-viewer/dashboard';
    } else if (role === 'dgt_admin') {
      window.location.href = '/app/dgt/dashboard';
    } else if (role === 'btp') {
      window.location.href = '/app/btp/dashboard';
    } else if (role === 'zaa_admin') {
      window.location.href = '/app/zaa/dashboard';
    } else if (role === 'saa_admin') {
      window.location.href = '/app/saa/dashboard';
    } else if (role === 'saa_ssdm_admin') {
      window.location.href = '/app/saa-ssdm/dashboard';
    } else if (role === 'csc_admin') {
      window.location.href = '/app/csc_admin/dashboard';
    } else if (role === 'aaa_admin') {
      window.location.href = '/app/aaa/dashboard';
    } else if (role === 'rdat_admin') {
      window.location.href = '/app/rdat/dashboard';
    } else if (role === 'ssdm_admin') {
      window.location.href = '/app/ssdm/dashboard';
    } else if (role === 'ssc_admin') {
      window.location.href = '/app/ssc/dashboard';
    } else if (role === 'jaa_admin') {
      window.location.href = '/app/jaa/dashboard';
    } else if (role === 'nsdc_finance_admin') {
      window.location.href = 'app/nsdc-finance/dashboard';
    } else if (role === 'nsdc_cfo_admin') {
      window.location.href = 'app/nsdc-cfo/dashboard';
    }  else if (role === 'inspection_agency') {
      window.location.href = '/app/inspection_agency/dashboard';
    } else if (role === 'dgt_finance_admin') {
      window.location.href = 'app/dgt-finance/dashboard';
    } else if (role === 'dgt_cfo_admin') {
      window.location.href = 'app/dgt-cfo/dashboard';
    }  else if (role === 'desktop_assessor') {
      window.location.href = '/app/desktop_assessor/dashboard';
    } else if (role === 'cma') {
      window.location.href = '/app/cma/dashboard';
    } else if(role === 'aa_admin') {
      window.location.href = '/app/aa/dashboard';
    } else if(role === 'assessor') {
      window.location.href = '/app/assessor/dashboard';
    }else if(role === 'caa_admin') {
      window.location.href = '/app/caa/dashboard';
    }else if(role === 'dgt_gr_admin') {
      window.location.href = '/app/dgt-gr/dashboard';
    }else if(role === 'nsdc_standard') {
      window.location.href = '/app/rbac/dashboard';
    }else if(role === 'daa_admin') {
      window.location.href = '/app/daa/dashboard';
    }else if(role === 'sankalp_admin') {
      window.location.href = '/app/sankalp/dashboard';
    }else if(role === 'state_desktop_assessor') {
      window.location.href = '/app/state_da/dashboard';
    }else if(role === 'dbt_approval') {
      window.location.href = '/app/dbt-approval/payroll/dbt-view-for-dbt-approver';
    }else if(role === 'secretary_msde_admin') {
      window.location.href = '/app/msde/dashboard';
    }else if (role === 'support') {
      window.location.href = '/app/support/dashboard';
    } else {
      this.router.navigate(['/unauthorized']);
    }
  }
}
